/**
 * ElixioConnect Vue 2 Plugin
 *
 * Usage:
 *   import ElixioConnect from '@latactik/elixio-connect-components-vue2'
 *   Vue.use(ElixioConnect, {
 *     apiBaseUrl: 'https://api.example.com/api',
 *     locale: 'fr',
 *     holderType: 'Organization',
 *     holderId: '1',
 *     authToken: 'your-bearer-token',
 *   })
 */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './styles/index.scss'
import { initApiClient } from './api/client'
import { fr, en } from './i18n'
import * as uiComponents from './components/ui'

const defaultTranslations = { fr, en }

export default {
  install(Vue, options = {}) {
    // Register Element UI (required by Ec* UI components)
    Vue.use(ElementUI)

    // Register all Ec* UI components globally
    Object.entries(uiComponents).forEach(function ([name, component]) {
      Vue.component(name, component)
    })

    // Initialize API client
    if (options.apiBaseUrl || options.httpClient) {
      initApiClient(options)
    }

    // Locale
    const locale = options.locale || 'fr'

    // Translation function
    const customTranslate = options.translate || null
    const translations = options.translations
      ? { ...defaultTranslations, ...options.translations }
      : defaultTranslations

    function ecTranslate(key, params) {
      if (customTranslate) return customTranslate(key, params)

      const parts = key.split('.')
      let result = translations[locale]
      for (const part of parts) {
        if (result && typeof result === 'object') {
          result = result[part]
        } else {
          return key
        }
      }
      let str = result || key
      if (params && typeof str === 'string') {
        str = str.replace(/\{(\w+)\}/g, function (_, k) {
          return params[k] !== undefined ? String(params[k]) : '{' + k + '}'
        })
      }
      return str
    }

    // Notify function
    const ecNotify = options.notify || function () {}

    // Confirm function
    const ecConfirm = options.confirm || function (msg) {
      return Promise.resolve(window.confirm(msg))
    }

    // Provide globally via prototype
    Vue.prototype.$ecTranslate = ecTranslate
    Vue.prototype.$ecNotify = ecNotify
    Vue.prototype.$ecConfirm = ecConfirm
    Vue.prototype.$ecLocale = locale
    Vue.prototype.$ecOptions = options
  },
}
